import { QuestionService } from './question.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';

import { Student } from '../student-list/student';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class StudentService {
	constructor(private http: HttpClient) {
		this._selectedStudent$ = new Subject();
	}
	private _selectedStudent$: Subject<Student>;
	private selectedStudentObj: Student;

	/**
	 * Submits a score
	 * @param id
	 * @param testSystemId
	 * @param date
	 * @param assessmentBookId
	 * @param assessmentTemplateId
	 * @param score
	 * @returns Observable<any>
	 */
	public submitScore(payload): Observable<any> {
		return this.http.post<any>(`${environment.apiUrl}/assessment/add`, payload);
	}

	/**
	 * Gets students$
	 * @param nodeId
	 * @returns students$
	 */
	public getStudents$(nodeId: number): Observable<Student> {
		return this.http.get<Student>(`${environment.apiUrl}/main/students/nodeId/${nodeId}`);
	}
	/**
	 * Gets scores$
	 * @param id
	 * @param testSystemId
	 * @returns scores$
	 */
	public getScoreTotal$(id: number, testSystemId: number, assessmentBookId, assessmentTemplateId): Observable<any> {
		return this.http.get<any>(
			`${environment.apiUrl}/main/scoretotal/participantId/${id}/testSystemId/${testSystemId}/assessmentBookId/${assessmentBookId}/assessmentTemplateId/${assessmentTemplateId}`
		);
	}
	public readyForNextPhase(id: number, assessmentBookId, assessmentTemplateId): Observable<any> {
		return this.http.get<any>(
			`${environment.apiUrl}/main/readyForNextPhase/participantId/${id}/assessmentBookId/${assessmentBookId}/assessmentTemplateId/${assessmentTemplateId}`
		);
	}
	/**
	 * Gets selected student$
	 */
	get selectedStudent$() {
		return this._selectedStudent$.asObservable();
	}

	/**
	 * Sets student
	 * @param Student
	 */
	public setStudent(Student: Student) {
		console.log(Student);
		this._selectedStudent$.next(Student);
		localStorage.setItem('selectedStudent', JSON.stringify(Student));
		this.selectedStudentObj = Student;
	}

	public triggerStudentChange(triggerFlag) {
		let studentObj: Student = JSON.parse(localStorage.getItem('selectedStudent'));
		studentObj.triggerFlag = triggerFlag;
		this._selectedStudent$.next(studentObj);
		this.selectedStudentObj = studentObj;
	}

	public getSelectedStudentAsObj() {
		return this.selectedStudentObj;
	}
}
